export enum QuestionType {
  SingleChoice = 'SingleChoice',
  MultipleChoice = 'MultipleChoice',
  FillInBlank = 'FillInBlank',
  ShortAnswer = 'ShortAnswer',
  RandomQuestions = 'RandomQuestions',
  TrueOrFalse = 'TrueOrFalse',
  ImageSingleChoice = 'ImageSingleChoice',
  ImageMultipleChoice = 'ImageMultipleChoice',
  MultipleBlank = 'MultipleBlank',
}

export enum QuestionRuleType {
  FixedRule = 'FixedRule',
  RandomRule = 'RandomRule',
}

export type SelectableQuestionType = QuestionType.SingleChoice | QuestionType.MultipleChoice | QuestionType.TrueOrFalse

export type Plan = {
  label: string
  code: PlanCode
  icon: any
  featureQuota: {
    ai_question_bank_calls_per_day: number
    ai_question_bank_text_length: number
    customers_count_per_form: number
    ai_question_count_per_task: number
    sub_account: number
  }
}

export type PlanPackage = {
  plan: { code: PlanCode; label: string }
  endDate?: any | null
  trial?: boolean | null
  paidByYear?: boolean | null
  featureQuota?: Record<keyof Plan['featureQuota'], number>
}

export type Profile = {
  id: string
  avatarUrl: string
  mobile: string
  name: string
  role: string
  createdAt: string
  billingAccount?: {
    id: string
    name: string
    planPackage: PlanPackage
  }
}

export enum PlanCode {
  /** 企业版 */
  Ent = 'ent',
  /** 免费版 */
  Free = 'free',
  /** 专业版 */
  Pro = 'pro',
  /** 标准版 */
  Std = 'std',
  /** 旗舰版 */
  Ultra = 'ultra',
  /** 试用版 */
  Trial = 'trial',
  /** 单次付费 */
  Lite = 'lite',
}

export type UpdateProfileArgs = {
  name?: string
  avatar?: {
    attachmentId: string
    cropX?: number
    cropY?: number
    cropW?: number
    cropH?: number
  }
}

export enum FileCategory {
  Word = 'Word',
  Excel = 'Excel',
  PDF = 'PDF',
  PPT = 'PPT',
}

export enum CreationType {
  OneLine = 'oneline',
  QuestionBank = 'question_bank',
  KnowledgeBase = 'knowledge_base',
}
